/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Actiontextlabel2Inputs */

const en_actiontextlabel2 = /** @type {(inputs: Actiontextlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text`)
};

const de_actiontextlabel2 = /** @type {(inputs: Actiontextlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text`)
};

/**
* | output |
* | --- |
* | "Text" |
*
* @param {Actiontextlabel2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const actiontextlabel2 = /** @type {((inputs?: Actiontextlabel2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actiontextlabel2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_actiontextlabel2(inputs)
	return de_actiontextlabel2(inputs)
});
export { actiontextlabel2 as "actionTextLabel" }